import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/event/fullscreen-1.png',
  title: 'Fullscreen 1',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Event Fullscreen 1',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'image',
          name: 'Tagboard',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/logos/tagboard-brushstroke.png`,
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 1300,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 0,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 811,
            left: 766,
            width: 386,
            height: 114,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Powered by',
          locked: false,
          text: '<p class="ql-align-center">Powered by</p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 1300,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 0,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: true,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 750,
            left: 610,
            width: 700,
            height: 60,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'White river amphitheatre',
          locked: false,
          text: '<p class="ql-align-center"><strong>WHITE RIVER AMPHITHEATRE</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInDown',
          animationInDuration: 300,
          animationInDelay: 1000,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutUp',
          animationOutDuration: 300,
          animationOutDelay: 300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 640,
            left: 610,
            width: 700,
            height: 40,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 9,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: '2020',
          locked: false,
          text: '<p class="ql-align-center"><strong>2020</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInDown',
          animationInDuration: 300,
          animationInDelay: 1000,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutUp',
          animationOutDuration: 300,
          animationOutDelay: 300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 470,
            left: 540,
            width: 900,
            height: 170,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 170,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 60,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Music festival',
          locked: false,
          text: '<p class="ql-align-center"><strong>Music festival</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInDown',
          animationInDuration: 300,
          animationInDelay: 1000,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutUp',
          animationOutDuration: 300,
          animationOutDelay: 300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 380,
            left: 610,
            width: 700,
            height: 90,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 60,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 5,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Diamond 2',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'zoomIn',
          animationInDuration: 300,
          animationInDelay: 700,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'zoomOut',
          animationOutDuration: 300,
          animationOutDelay: 600,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'gradient',
          backgroundColor: '#0F84FB',
          backgroundSize: 'cover',
          gradientDirection: 135,
          gradientColorOne: 'rgb(255, 208, 19)',
          gradientColorTwo: 'rgb(204, 0, 127)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 45,
          styles: {
            top: 180,
            left: 600,
            width: 720,
            height: 720,
            opacity: '0.50',
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Diamond 1',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'zoomIn',
          animationInDuration: 300,
          animationInDelay: 600,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'zoomOut',
          animationOutDuration: 300,
          animationOutDelay: 700,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: true,
          borderWidth: 15,
          borderColor: 'rgb(204, 0, 127)',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 45,
          styles: {
            top: 90,
            left: 510,
            width: 900,
            height: 900,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Sacred',
          locked: false,
          text: '<p><strong>sacred</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 300,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 1000,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 720,
            left: 50,
            width: 1920,
            height: 360,
            opacity: '0.20',
            color: 'rgb(163, 0, 102)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 360,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Is',
          locked: false,
          text: '<p><strong>is</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 300,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 1000,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 360,
            left: 50,
            width: 1920,
            height: 360,
            opacity: '0.20',
            color: 'rgb(163, 0, 102)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 360,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Nothing',
          locked: false,
          text: '<p><strong>Nothing</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 300,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 1000,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 0,
            left: 50,
            width: 1920,
            height: 360,
            opacity: '0.20',
            color: 'rgb(163, 0, 102)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 360,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Background',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/backgrounds/event-circles.jpg`,
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 0,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 1300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 0,
            left: 0,
            width: 1920,
            height: 1080,
            opacity: 1,
          },
        },
      ],
    };
  },
};
